import React, { useState } from "react";
import axiosInstance from "../axios/Axios";
import { useSelector, useDispatch } from "react-redux";
//MaterialUI
import ReactGoogleLogin from "react-google-login";
import { Formik, Form, Field } from "formik";
import { registerUser } from "../redux/slices/user/userSlice";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import * as Yup from "yup";

const validationSchema = Yup.object({
  first_name: Yup.string()
    .min(2, "Too short!")
    .max(20, "Too long!")
    .required("Your first name is required"),
  last_name: Yup.string()
    .min(2, "Too short!")
    .max(20, "Too long!")
    .required("Your last name is required"),
  email: Yup.string().email("Invalid Email").required("Email Required"),
});

export default function SignUp() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
  };
  const onSubmit = (values, onSubmitProps) => {
    console.log("Form Data", values);
    dispatch(
      registerUser({
        ...values,
        navigate: navigate,
        onSubmitProps: onSubmitProps,
      })
    );
  };
  const registerMessage = useSelector((state) => state.user.registerMessage);
  console.log(registerMessage);

  return (
    <>
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h2 className="mt-28 text-left font-Montserrat text-2xl font-bold text-black">
              Create an account
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
          </div>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnMount
          >
            <Form className="mt-10 space-y-10">
              <Field name="first_name">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="First Name"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="last_name">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Last Name"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field name="email">
                {(props) => {
                  const { field, form, meta } = props;
                  return (
                    <>
                      <input
                        {...field}
                        type="text"
                        {...(meta.touched && meta.error
                          ? {
                              className:
                                "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                            }
                          : {
                              className:
                                "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                            })}
                        placeholder="Email"
                      ></input>
                      {meta.touched && meta.error ? (
                        <label className="text-xs font-semibold font-Montserrat text-red-500">
                          <span className="ml-1">{meta.error}</span>
                        </label>
                      ) : null}
                    </>
                  );
                }}
              </Field>
              <Field>
                {(props) => {
                  const { field, form, meta } = props;
                  const { isSubmitting } = form;
                  return (
                    <>
                      {!isSubmitting ? (
                        <button
                          type="submit"
                          {...(form.isValid
                            ? {
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow ",
                              }
                            : {
                                disabled: true,
                                className:
                                  "font-Montserrat font-semibold text-white flex-shrink bg-blue-200 hover:bg-blue-100 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow opacity-50 cursor-not-allowed",
                              })}
                        >
                          Sign Up
                        </button>
                      ) : (
                        <button
                          disabled
                          className="font-Montserrat font-semibold flex-shrink bg-blue-200 place-content-center w-full rounded-sm px-4 py-2 flex flex-grow"
                        >
                          <div className="flex items-center justify-center space-x-2 animate-pulse">
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                            <svg className="w-5 h-5 bg-blue-300 rounded-full"></svg>
                          </div>
                        </button>
                      )}
                    </>
                  );
                }}
              </Field>
              <div>
                <p className="-my-6 text-center text-xs font-Montserrat font-semibold text-black">
                  Already have an account?{" "}
                  <Link
                    className="font-Montserrat text-blue-200 font-semibold"
                    to="/login"
                  >
                    Login
                  </Link>
                </p>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </>
  );
}
